module.exports={author:"Max Seifert",date:"11/08/2019",publishDate:"11/08/2019",highlighted:!1,tags:"",title:"Benjamins"};